import React, { useCallback, useContext, useEffect, useState } from "react";
import CommissaryLayout from "../../layout/CommissaryLayout";
import { Tabs } from "antd";
import EmployeeList from "./list";
import PositionList from "./position";
import axios from "axios";
import { UserInfo } from "../../../context";

const CommissaryEmployee = () => {
  const [positionList, setPositionList] = useState({ data: [], ready: false });
  const { userData } = useContext(UserInfo);

  const items = [
    {
      key: "1",
      label: `Employee`,
      children: (
        <EmployeeList
          positionList={positionList}
          rerun={() => getPositionList()}
        />
      ),
    },
    {
      key: "2",
      label: `Position`,
      children: (
        <PositionList
          positionList={positionList}
          rerun={() => getPositionList()}
        />
      ),
    },
  ];

  const getPositionList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/position-list", { params })
      .then((response) => {
        const data = response.data;
        setPositionList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getPositionList();
  }, [getPositionList]);

  return (
    <CommissaryLayout>
      <Tabs defaultActiveKey="1" items={items} />
    </CommissaryLayout>
  );
};

export default CommissaryEmployee;
